import {IconButton} from '@chakra-ui/react';
import {ArrowDownAZ, ArrowUpAZ} from 'lucide-react';
import {SortDirection} from '../domain/ordering';

interface SortToggleButtonProps {
    direction: SortDirection;
    onToggle: () => void;
}

/** Switches a folder's listing between A to Z and Z to A; the icon shows the current order. */
export function SortToggleButton({direction, onToggle}: SortToggleButtonProps) {
    const isAscending = direction === 'asc';
    return <IconButton
        size="sm"
        variant="outline"
        aria-label={isAscending ? 'Rendezés: növekvő (A–Z)' : 'Rendezés: csökkenő (Z–A)'}
        title={isAscending ? 'Növekvő sorrend (A–Z) — kattints a csökkenőhöz' : 'Csökkenő sorrend (Z–A) — kattints a növekvőhöz'}
        onClick={onToggle}
    >
        {isAscending ? <ArrowDownAZ size={18}/> : <ArrowUpAZ size={18}/>}
    </IconButton>;
}
